@if(details() && (details()?.title || details()?.name) ){
<div class="d-flex flex-row gap-1 " [class.flex-column]="isMobile" [class.justify-content-center]="isMobile">

  @if(showPhoto()){
  <div class="d-flex" [class.justify-content-center]="isMobile">

    <cnet-avatar class="user-avatar" size="large" [src]="details()?.urlPhoto" [alt]="details()?.title" />
  </div>
  }

  <div class="align-self-stretch d-flex flex-column extra-small-gap w-100" [class.text-center]="isMobile"
    [class.align-items-center]="isMobile">

    <h3 class="title m-0 text-break">
      @if(details()?.translateTitle){
      {{details()?.title | translate}}
      }@else {
      {{(details()?.title || details()?.name)}}
      {{details()?.fiscalCodeNumber ? (' - ' + (details()?.fiscalCodeNumber | fiscalCode:details()?.fiscalCodeCountryCode:'Natural')
      ):
      ''}}
      }

    </h3>

    @if(details()?.subTitle|| details()?.email){
    <p class="mb-1 text-break description">
      @if(details()?.translateSubTitle){
      {{details()?.subTitle | translate}}
      }@else {
      {{details()?.subTitle || details()?.email }}
      }
    </p>
    }

    @if(details()?.isPwd || details()?.address){
    <div class="d-flex flex-row flex-wrap gap-1" [class.justify-content-center]="isMobile">
      @if(details()?.isPwd){
      <p class="d-flex align-items-start fit-content m-0">
        <cnet-icon name="universal-access" [color]="'warning'" />
        {{"Pessoa com Deficiência (PCD)" | translate}}
      </p>
      }
      <p class="d-flex align-items-start  fit-content m-0">
        <cnet-icon name="map-marker" [color]="'warning'" />
        {{details()?.address | formatAddress }}
      </p>
    </div>
    }
    @if(details()?.curriculumLink){
    <p class="description" *ngxPermissionsOnly="'OpportunityModuleAccess'">
      <a class="link" aria-label="fileUrl" [href]="details()?.curriculumLink" target="_blank">
        {{ "Acessar o currículo" | translate }}
      </a>
    </p>
    }

    @if(details()?.role){
    <p cnet-badge cnet-badge-type="stroked" cnet-badge-color="primary" class="fit-content m-0">
      {{details()?.role | permissionRoleId}}</p>
    }

    @if(showGroups() && details()?.groups?.length){
    <div>
      @for(group of details()?.groups; track group){
      <p cnet-badge cnet-badge-type="stroked" cnet-badge-color="default" class="text-capitalize fit-content mr-1">
        {{group }}</p>
      }
    </div>

    }


  </div>

</div>

}@else {
<div class="d-flex flex-row align-items-center gap-1" [class.flex-column]="isMobile"
  [class.justify-content-center]="isMobile">

  @if(showPhoto()){
  <div>
    <div cnet-avatar class="loading-avatar"></div>
  </div>
  }
  <div class="align-self-stretch d-flex flex-column w-100 extra-small-gap" [class.align-items-center]="isMobile">
    <div class="m-0 w-100">
      <div class="loading w-100"></div>
    </div>
    <div class="loading-description w-50"></div>
    <div class="loading-description w-50"></div>
    @if(showGroups()){
    <div class="loading-description w-50"></div>
    }
  </div>
</div>
}